export default {
  SET_SOCIAL_MEDIAS (state, social_medias) {
    state.social_medias = social_medias
  },
  REMOVE_RECORD (state, itemId) {
    const roleIndex = state.social_medias.findIndex((u) => u.id === itemId)
    state.social_medias.splice(roleIndex, 1)
  }
}
